import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  // --------------------------内嵌页面
  {
    path: '/',
    name: 'home',
    component: () => import('../views/HomeView.vue')
  }
  // --------------------------h5页面
  // {
  //   path: '/',
  //   name: 'home',
  //   component: () => import('../views/HomePage.vue')
  // },
  // {
  //   path: '/types',
  //   name: 'hometypes',
  //   component: () => import('../views/HomeTypes.vue')
  // },
  // {
  //   path: '/bike',
  //   name: 'HomeBike',
  //   component: () => import('../views/HomeBike.vue')
  // },
  // {
  //   path: '/about',
  //   name: 'AboutUs',
  //   component: () => import('../views/AboutUs.vue')
  // },
  // {
  //   path: '/privacy',
  //   name: 'privacy',
  //   component: () => import('../views/privacy.vue')
  // },
  // {
  //   path: '/securityNotice',
  //   name: 'securityNotice',
  //   component: () => import('../views/securityNotice.vue')
  // },
  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  // }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savePositon) {
    if (savePositon) {
      return savePositon;
    }
    return { x: 0, y: 0 };
  }
})

export default router
